export default "__VITE_ASSET__698f105a__"